import classnames from 'classnames';

import style from './RemoveButton.module.scss';
import '@components/mixins/commonStyles.scss';

import { Icon, IconType } from '@components/Icon';

interface RemoveButtonProps {
    text?: string;
    disabled?: boolean;
    theme?: RemoveButtonTheme;
    modifiers?: RemoveButtonModifiers[];
    dataTest?: string;
    onRemoveClick(e?: React.MouseEvent<HTMLDivElement>): void;
}

export enum RemoveButtonTheme {
    // @ts-ignore
    Small = style.root_small,
    // @ts-ignore
    Big = style.root_big,
}

export enum RemoveButtonModifiers {
    // @ts-ignore
    PositionBottomRight = style.root_positionBottomRight,
    // @ts-ignore
    PositionTopRight = style.root_positionTopRight,
}

export function RemoveButton({
    text,
    disabled,
    theme = RemoveButtonTheme.Small,
    modifiers = [],
    dataTest,
    onRemoveClick,
}: RemoveButtonProps) {
    return (
        <div
            className={classnames([
                style.root,
                disabled && style.root_disable,
                !!text && style.root_withText,
                theme,
                ...modifiers,
            ])}
            data-test={dataTest}
            data-testid={dataTest}
            onClick={disabled ? undefined : onRemoveClick}
        >
            <div className={style.icon}>
                <Icon type={theme === RemoveButtonTheme.Big ? IconType.TRASH_REDESIGN : IconType.TRASH} />
            </div>
            {text && <div className={classnames([style.text, 'font_caption'])}>{text}</div>}
        </div>
    );
}
